const normalize = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');

const isColorInput = (input) => {
  const fieldset = input.closest('fieldset');
  const label = fieldset?.querySelector('legend span')?.textContent || input.name;

  return /colou?r/i.test(label);
};

const findSelectedColorInput = () =>
  Array.from(document.querySelectorAll('variant-picker input[type="radio"]:checked')).find(isColorInput);

const findMatchingMediaIndex = (gallery, color) => {
  const colorKey = normalize(color);
  if (!colorKey) return -1;

  const slides = Array.from(gallery.querySelectorAll('slideshow-slide'));

  return slides.findIndex((slide) => {
    const image = slide.querySelector('img');
    const imageText = normalize(
      `${image?.getAttribute('src') || ''} ${image?.getAttribute('srcset') || ''} ${image?.getAttribute('alt') || ''}`
    );

    return imageText.includes(colorKey);
  });
};

const mediaElementMatchesColor = (element, color) => {
  const colorKey = normalize(color);
  if (!colorKey) return true;

  const image = element.querySelector('img');
  const imageText = normalize(
    `${image?.getAttribute('src') || ''} ${image?.getAttribute('srcset') || ''} ${image?.getAttribute('alt') || ''}`
  );

  return imageText.includes(colorKey);
};

const filterGalleryMediaByColor = (gallery, color) => {
  const filterableSelectors = [
    'slideshow-slide',
    '.media-gallery__grid > li',
    '.slideshow-controls__thumbnail',
    '.dialog-thumbnails-list__thumbnail',
    '.dialog-zoomed-gallery > li',
  ];

  filterableSelectors.forEach((selector) => {
    gallery.querySelectorAll(selector).forEach((element) => {
      const matchesColor = mediaElementMatchesColor(element, color);
      element.hidden = !matchesColor;
      element.style.display = matchesColor ? '' : 'none';
    });
  });
};

const selectGalleryMedia = (gallery, index) => {
  if (index < 0) return;

  const control = Array.from(gallery.querySelectorAll('button')).find(
    (button) => button.getAttribute('on:click') === `/select/${index}`
  );

  if (control) {
    control.click();
    return;
  }

  const slide = gallery.querySelectorAll('slideshow-slide')[index];
  slide?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
};

const syncGalleryToColor = (color) => {
  document.querySelectorAll('media-gallery').forEach((gallery) => {
    filterGalleryMediaByColor(gallery, color);
    const index = findMatchingMediaIndex(gallery, color);
    selectGalleryMedia(gallery, index);
  });
};

const syncSelectedColor = () => {
  const input = findSelectedColorInput();
  if (input) syncGalleryToColor(input.value);
};

document.addEventListener('change', (event) => {
  const input = event.target;
  if (!(input instanceof HTMLInputElement) || input.type !== 'radio' || !isColorInput(input)) return;

  requestAnimationFrame(() => syncGalleryToColor(input.value));
});

document.addEventListener('DOMContentLoaded', syncSelectedColor);
document.addEventListener('shopify:section:load', syncSelectedColor);
requestAnimationFrame(syncSelectedColor);
